// Score bands aligned to the matching engine:
// 90-100 Exceptional · 80-89 Strong · 70-79 Good · 60-69 Maybe · <60 Reject
export const getScoreClass = (score) => {
  if (score >= 80) return 'score-excellent';
  if (score >= 70) return 'score-good';
  if (score >= 60) return 'score-maybe';
  return 'score-risk';
};

export const getScoreColor = (score) => {
  if (score >= 90) return '#059669';
  if (score >= 80) return '#10B981';
  if (score >= 70) return '#005DEB';
  if (score >= 60) return '#F59E0B';
  return '#EF4444';
};

// Fit-band metadata for both the new 5-band engine and legacy labels
// (already-scored candidates), so colors stay consistent across the app.
export const FIT_META = {
  Exceptional: { color: '#059669', className: 'score-excellent' },
  Strong: { color: '#10B981', className: 'score-excellent' },
  Good: { color: '#005DEB', className: 'score-good' },
  Maybe: { color: '#F59E0B', className: 'score-maybe' },
  Reject: { color: '#EF4444', className: 'score-risk' },
  // legacy labels
  'Strong Fit': { color: '#059669', className: 'score-excellent' },
  'Good Fit': { color: '#10B981', className: 'score-good' },
  'Moderate Fit': { color: '#F59E0B', className: 'score-maybe' },
  'Partial Fit': { color: '#F59E0B', className: 'score-maybe' },
  'Weak Fit': { color: '#EF4444', className: 'score-risk' },
  'Not a Fit': { color: '#EF4444', className: 'score-risk' },
  Unknown: { color: '#94A3B8', className: '' },
};

export const getFitColor = (fit) => FIT_META[fit]?.color || '#94A3B8';
export const getFitClass = (fit) => FIT_META[fit]?.className || '';

// New engine fit bands (for feedback correction dropdowns etc.)
export const FIT_BANDS = ['Exceptional', 'Strong', 'Good', 'Maybe', 'Reject'];
